var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTbc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .135h9.695v17.293H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.058.03h19.528v6.038H.058z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .025)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#01A3DF",
    d: "M9.288 10.496c.089.883.138 1.335-.58 2.091-.745.786-2.61 2.23-4.516 3.329-.805.471-1.895 1.03-2.72 1.325-.608.226-1.119.315-1.374-.127-.167-.285-.088-.55 0-.776.667-1.797 2.572-5.165 3.82-7.344.127-.226.264-.452.392-.688C6.235 4.997 8.778.942 9.278.294c.07-.098.207-.206.324-.137.099.059.099.177.089.265 0 .01-.03.127-.05.177-.814 3.348-.726 6.627-.353 9.897",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#01A3DF",
    d: "M12.096 11.551c-.805-.373-1.227-.56-1.522-1.56-.304-1.032-.628-3.369-.628-5.578 0-.923.059-2.14.206-3.004.118-.648.295-1.14.805-1.14.334 0 .52.207.678.393 1.227 1.473 3.171 4.812 4.448 6.991.127.216.255.442.392.678 1.905 3.319 4.144 7.55 4.458 8.307.05.108.079.274-.049.353-.098.05-.196-.01-.265-.059l-.128-.128c-2.494-2.386-5.37-3.947-8.395-5.253"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.639 12.799)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#01A3DF",
    d: "M9.16.658c.727-.511 1.1-.776 2.111-.54 1.041.255 3.23 1.148 5.145 2.248.795.461 1.826 1.13 2.504 1.689.49.422.834.815.58 1.257-.168.284-.433.353-.678.392-1.895.325-5.764.344-8.277.364h-.786c-3.83-.01-8.611-.187-9.426-.295-.118-.01-.275-.069-.275-.216 0-.108.098-.177.177-.206.02 0 .137-.04.177-.05C3.72 4.34 6.519 2.632 9.16.659",
    mask: "url(#d)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbc);
export default __webpack_public_path__ + "static/media/tbc.a575b3eaf34c7a0a0568b6f86a19787c.svg";
export { ForwardRef as ReactComponent };